import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PipesModule } from '../../pipes/pipes.module';

import { ButtonComponent } from '../button/button.component';
import { FormComponent } from './form.component';
import { FormErrorsComponent } from './form-errors/form-errors.component';
import { FormRowComponent } from './row/form-row.component';
import { InputErrorsComponent } from './input-errors/input-errors.component';
import { InputGroupComponent } from './input-group/input-group.component';
import { InputGroupFieldComponent } from './input-group/input-group-field.component';
import { InputGroupLabelComponent } from './input-group/input-group-label.component';
import { InputStatusIndicatorDirective } from './input-status/input-status-indicator.directive';
import { FormAccessibilityAlertComponent } from './accessibility-alert/form-accessibility-alert.component';
import { FormFooterComponent } from './footer/form-footer.component';
import { FormFooterStartComponent } from './footer/form-footer-start.component';
import { FormFooterEndComponent } from './footer/form-footer-end.component';
import { InputGroupSuffixComponent } from './input-group/input-group-suffix.component';
import { InputGroupNoteComponent } from './input-group/input-group-note.component';
import { FormAccessibilityService } from './accessibility-alert/form-accessibility.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    ButtonComponent,
    FormComponent,
    FormErrorsComponent,
    FormRowComponent,
    FormFooterComponent,
    FormFooterStartComponent,
    FormFooterEndComponent,
    FormAccessibilityAlertComponent,
    InputErrorsComponent,
    InputGroupComponent,
    InputGroupFieldComponent,
    InputGroupLabelComponent,
    InputStatusIndicatorDirective,
    InputGroupSuffixComponent,
    InputGroupNoteComponent
  ],
  exports: [
    FormsModule,
    FormComponent,
    FormErrorsComponent,
    FormRowComponent,
    FormFooterComponent,
    FormFooterStartComponent,
    FormFooterEndComponent,
    FormAccessibilityAlertComponent,
    InputErrorsComponent,
    InputGroupComponent,
    InputGroupFieldComponent,
    InputGroupLabelComponent,
    InputStatusIndicatorDirective,
    InputGroupSuffixComponent,
    InputGroupNoteComponent
  ],
  providers: [FormAccessibilityService]
})
export class FormModule {
}
